import { useMemo, useState } from 'react';
import { createDefaultRange, toApiDateRange } from '../utils/dateRange';
import type { ApiDateRange } from '../utils/dateRange';
import type { DateRange } from '../../../commonComponents/DateRangePicker/types';

export interface DateRangeFilter {
  dateRange: DateRange;
  setDateRange: (next: DateRange) => void;
  /** The same range as the `startDate`/`endDate` query params. */
  apiRange: ApiDateRange;
}

/**
 * Date-range state for a range-scoped screen, plus its API param form.
 *
 * Opens on the trailing 30 days every range-scoped endpoint defaults to server-side,
 * so the first render matches what the API would have returned unfiltered.
 */
export function useDateRangeFilter(): DateRangeFilter {
  const [dateRange, setDateRange] = useState<DateRange>(createDefaultRange);

  const apiRange = useMemo(() => toApiDateRange(dateRange), [dateRange]);

  return { dateRange, setDateRange, apiRange };
}
